import script from "./EmbeddedAppPool.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmbeddedAppPool.vue?vue&type=script&setup=true&lang=ts"

import "./EmbeddedAppPool.vue?vue&type=style&index=0&id=44c3722c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44c3722c"]])

export default __exports__